const formatDate = (dateString) => {
    if (typeof dateString === 'undefined' || typeof dateString !== 'string') {
        return ''
    }
    let date = new Date(dateString)
    let offset = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()
    return offset.split('T')[0]
}

export default formatDate